// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useMemo } from 'react';

import { workOrderStateNames } from '@evolvemep/api-ts';

import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { WrappedMultiSelect } from 'components/Mantine/TypeSafeSelect/WrappedMultiSelect';
import { isNil } from 'helpers/isNotNil';
import { useWorkOrderStatuses } from 'hooks/typeCacheHooks/useWorkOrderStatuses';

export const WorkOrderStatesFilter = ({ filter, value, onChange }: GlobalFilterProps<'workOrderStates'>) => {
  const { states, loading } = useWorkOrderStatuses();
  const validStates = useMemo(
    () =>
      (states?.filter((s) => filter?.includes(s.name)) ?? []).toSorted(
        (a, b) => workOrderStateNames.indexOf(a.name) - workOrderStateNames.indexOf(b.name),
      ),
    [filter, states],
  );
  if (isNil(filter) || filter.length === 0) return null;
  return (
    <WrappedMultiSelect
      value={value.map((s) => s.stateId)}
      onChange={(v) => onChange(validStates.filter((u) => v.includes(u.stateId)))}
      loading={loading}
      data={validStates.map((s) => ({
        label: s.name,
        value: s.stateId,
      }))}
      label="Statuses"
      placeholder="All Statuses"
      searchable
      clearable
      comboboxProps={{
        withinPortal: false,
      }}
    />
  );
};
